import CStorage from "./CStorage";
import Vue from 'vue';

export default {
    trackEventOnes(eventId, event) {
        const key = 'eventId.' + eventId
        const exists = CStorage.getItem(key, null)
        if (!exists && Vue.gtm) {
            Vue.gtm.trackEvent(event)
            CStorage.setItem(key, 1)
        }
    },
}
